import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0109',
    ecrans: ['00-2'],
    params: ['id',
             '?doccleintref' ]
});

